/* ═══════════════════════════════════════════════════════════════
   assets/kioraa-trust-signup.js
   Kioraa "Trust signup" bar → Klaviyo
   Mirrors the Kioraa Popup submission (same Klaviyo client API + same list).
   ═══════════════════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* Shared with the popup so "already subscribed" works across Kioraa forms on the same device */
  var STORAGE_KEY = 'kioraa_popup_emails';

  function getEmails() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }

  function saveEmail(email) {
    try {
      var list  = getEmails();
      var lower = email.toLowerCase();
      if (list.indexOf(lower) === -1) {
        list.push(lower);
        localStorage.setItem(STORAGE_KEY, JSON.stringify(list));
      }
    } catch (e) {}
  }

  function alreadySubmitted(email) {
    return getEmails().indexOf(email.toLowerCase()) !== -1;
  }

  /* Popup is loaded globally — fall back to its Klaviyo config so this bar
     always targets the SAME list without re-entering credentials. */
  var popup = document.getElementById('kioraa-popup-overlay');

  function init(form) {
    if (form.dataset.kioraaInit) return;     /* guard against double-binding */
    form.dataset.kioraaInit = '1';

    var companyId = (form.dataset.companyId || '').trim() || (popup ? (popup.dataset.companyId || '').trim() : '');
    var listId    = (form.dataset.listId    || '').trim() || (popup ? (popup.dataset.listId    || '').trim() : '');

    var msgEl = form.querySelector('.ts2__msg');
    var btn   = form.querySelector('button[type="submit"]');
    var input = form.querySelector('input[type="email"]');

    function showMsg(text, isError) {
      if (!msgEl) return;
      msgEl.textContent = text;
      msgEl.hidden = false;
      msgEl.classList.toggle('ts2__msg--error', !!isError);
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var email = input ? input.value.trim() : '';
      if (!email) return;

      /* Already submitted on this device? Show subscribed without an API call */
      if (alreadySubmitted(email)) {
        showMsg(form.dataset.subscribed || "You're already on the list!");
        return;
      }

      if (!companyId || !listId) {
        console.warn('[Kioraa Trust Signup] Missing Klaviyo Public API Key / List ID. Set them on the Kioraa Popup, or on this section.');
        showMsg(form.dataset.error || 'Something went wrong. Please try again.', true);
        return;
      }

      if (btn) btn.disabled = true;

      fetch(
        'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(companyId),
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'Accept': 'application/vnd.api+json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'Kioraa Trust Signup Bar',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: { email: email }
                  }
                }
              },
              relationships: {
                list: {
                  data: { type: 'list', id: listId }
                }
              }
            }
          })
        }
      )
      .then(function (res) {
        if (res.ok) {
          saveEmail(email);
          showMsg(form.dataset.success || 'Thanks for subscribing!');
          if (input) input.value = '';
        } else {
          res.text().then(function (txt) {
            console.error('[Kioraa Trust Signup Klaviyo Error]', res.status, txt);
          });
          if (btn) btn.disabled = false;
          showMsg(form.dataset.error || 'Something went wrong. Please try again.', true);
        }
      })
      .catch(function () {
        if (btn) btn.disabled = false;
        showMsg(form.dataset.error || 'Something went wrong. Please try again.', true);
      });
    });
  }

  document.querySelectorAll('form[data-kioraa-klaviyo]').forEach(init);

})();
